import React, { useState, useEffect } from 'react';
import axios from 'axios';
import UploadBalance from './components/UploadBalance';
import VariationsTable from './components/VariationsTable';
import './App.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

// Debug: afficher l'URL de l'API au chargement
console.log('🔍 App.js - REACT_APP_API_URL:', process.env.REACT_APP_API_URL);
console.log('🔍 App.js - API_URL utilisée:', API_URL);
console.log('🔍 App.js - Toutes les variables env:', Object.keys(process.env).filter(k => k.startsWith('REACT_APP_')));

function App() {
  const [periodes, setPeriodes] = useState([]);
  const [periode1, setPeriode1] = useState('');
  const [periode2, setPeriode2] = useState('');
  const [variations, setVariations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  // Charger les périodes disponibles
  const loadPeriodes = async () => {
    try {
      const response = await axios.get(`${API_URL}/periodes`);
      setPeriodes(response.data);
      
      // Sélectionner automatiquement les 2 dernières périodes
      if (response.data.length >= 2) {
        setPeriode1(response.data[1]); // Avant-dernière
        setPeriode2(response.data[0]); // Dernière
      }
    } catch (error) {
      console.error('Erreur chargement périodes:', error);
    }
  };

  useEffect(() => {
    loadPeriodes();
  }, []);

  // Charger les variations
  const loadVariations = async () => {
    if (!periode1 || !periode2) return;
    
    setLoading(true);
    try {
      const response = await axios.get(`${API_URL}/variations`, {
        params: { periode1, periode2 }
      });
      setVariations(response.data);
    } catch (error) {
      console.error('Erreur chargement variations:', error);
      alert('Erreur lors du chargement des variations');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (periode1 && periode2) {
      loadVariations();
    }
  }, [periode1, periode2]);

  // Sauvegarder un commentaire
  const handleSaveComment = async (numeroCompte, commentaire, auteur) => {
    try {
      await axios.post(`${API_URL}/commentaires`, {
        numero_compte: numeroCompte,
        commentaire,
        auteur
      });
      
      // Recharger les variations pour afficher le nouveau commentaire
      loadVariations();
      return true;
    } catch (error) {
      console.error('Erreur sauvegarde commentaire:', error);
      alert('Erreur lors de la sauvegarde du commentaire');
      return false;
    }
  };

  // Filtrer les variations selon la recherche
  const filteredVariations = variations.filter(v => 
    v.numero_compte?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    v.libelle_compte?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="App">
      <header className="App-header">
        <h1>📊 Gestion des Balances Comptables</h1>
      </header>

      <div className="container">
        <section className="upload-section">
          <UploadBalance onUploadSuccess={loadPeriodes} />
        </section>

        {periodes.length > 0 && (
          <>
            <section className="controls-section">
              <div className="period-selector">
                <div className="selector-group">
                  <label>Période 1 (ancienne) :</label>
                  <select 
                    value={periode1} 
                    onChange={(e) => setPeriode1(e.target.value)}
                  >
                    <option value="">Sélectionner...</option>
                    {periodes.map(p => (
                      <option key={p} value={p}>{p}</option>
                    ))}
                  </select>
                </div>

                <div className="selector-group">
                  <label>Période 2 (récente) :</label>
                  <select 
                    value={periode2} 
                    onChange={(e) => setPeriode2(e.target.value)}
                  >
                    <option value="">Sélectionner...</option>
                    {periodes.map(p => (
                      <option key={p} value={p}>{p}</option>
                    ))}
                  </select>
                </div>

                <div className="selector-group">
                  <label>Rechercher :</label>
                  <input
                    type="text"
                    placeholder="N° compte ou libellé..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              </div>
            </section>

            <section className="table-section">
              {loading ? (
                <div className="loading">Chargement des variations...</div>
              ) : (
                <VariationsTable
                  variations={filteredVariations}
                  periode1={periode1}
                  periode2={periode2}
                  onSaveComment={handleSaveComment}
                />
              )}
            </section>
          </>
        )}

        {periodes.length === 0 && (
          <div className="empty-state">
            <p>👆 Commencez par importer votre première balance Excel</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default App;
